import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import styles from './pageHeader.module.scss'
import Container from './container'
import Link from './link'

import IconHamburger from '../images/hamburger.js'
import IconClose from '../images/close.js'

class Header extends React.Component {
  state = { mobileMenuIsOpen: false }

  handleTriggerMenu() {
    this.setState({ mobileMenuIsOpen: !this.state.mobileMenuIsOpen })
    //prevent for scroll in mobile devices
    !this.state.mobileMenuIsOpen
      ? document.body.classList.add('modal-is-open')
      : document.body.classList.remove('modal-is-open')
  }

  render() {
    const { data, currentUrl } = this.props
    const menuIsOpen = this.state.mobileMenuIsOpen

    const Logo = () => (
      <img
        src={data.datoCmsPageHeader.logo.url}
        alt={data.datoCmsSite.name}
        className={styles.logo}
      />
    )

    return (
      <header className={styles.header}>
        <Container>
          {currentUrl === 'home' ? (
            <figure>
              <Logo />
            </figure>
          ) : (
            <Link to="/">
              <Logo />
            </Link>
          )}
          <nav
            className={`${styles.navigation} font-secondary`}
            data-opened={menuIsOpen}
            id="navigation"
          >
            <Link to="/">Home</Link>
            {data.datoCmsPageHeader.navigationLinks.map(link => (
              <Link
                key={link.id}
                to={`/${link.url}`}
                className={(currentUrl === link.url && 'active') || null}
              >
                {link.title}
              </Link>
            ))}
          </nav>
          <a href={data.datoCmsPageHeader.buttonLink} className={styles.login}>
            {data.datoCmsPageHeader.buttonText}
          </a>
          <button
            type="button"
            aria-expanded={menuIsOpen}
            aria-controls="navigation"
            className={styles.hamburger}
            onClick={() => this.handleTriggerMenu()}
          >
            {menuIsOpen ? <IconClose /> : <IconHamburger />}
          </button>
        </Container>
      </header>
    )
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        datoCmsPageHeader {
          logo {
            url
          }
          buttonText
          buttonLink

          navigationLinks {
            id
            title
            url
          }
        }
        datoCmsSite {
          name
        }
      }
    `}
    render={data => <Header data={data} {...props} />}
  />
)
